<template>
  <div class="dataForm" style="width:98%;">
    <template v-if="purchaseType === 1 && from !== 'local'">
      <div class="form-title mb-10">
        <span class="label blue" >购</span>
        <span class="left">采购信息</span>
      </div>
       <AccountPreview :account="detail.account" v-if="detail.account">
        <template v-slot:content>
          <el-descriptions-item label="是否含税：">{{detail.containsRate ? '是' : '否'}}</el-descriptions-item>
          <el-descriptions-item label="税率：">{{detail.rate || 0}}%</el-descriptions-item>
          <el-descriptions-item label="发票类型：">{{detail.invoiceTypeName}}</el-descriptions-item>
        </template>
      </AccountPreview>
      <!-- <div class="form-title mb-10 mt-10">
        <span class="label yellow" >物</span>
        <span class="left">物料信息</span>
      </div> -->
      <MateriallDescription :detail="detail.material" v-if="detail.material"/>
      <!-- <MaterialTable :materialData="detail.details" :storageVisible="true">
        <template v-slot:after>
          <el-table-column prop="command" label="操作" fixed="right" min-width="130">
            <template #default="{row}">
              <el-link type="primary" @click="handleAddComand(row)">添加</el-link>
              <el-link type="primary" @click="handleAddComand(row,true)" style="margin-left:10px" :disabled='row.virtualStorage===1' v-permission="{pkey:`PURCHASE_VIRTUAL_RUKU`}">虚拟入库</el-link>
            </template>
          </el-table-column>
        </template>
      </MaterialTable> -->
    </template>
    <!-- 采购表单 -->
    <el-form
      class="mb-20 mt-20"
      :ref="el => dataForm[index] = el"
      :model="item"
      label-position="top"
      label-width="100px"
      v-for="(item, index) in fromFieldData"
      :key="index"
    >
      <div class="form-title">
        <span class="label" :class="item.labelClass">{{item.labelName}}</span>
        <span class="left">{{item.title}}</span>
        <span @click="handleAddComand" class="add-icon add-title cursor" v-if="item.type === 2 && !item.formList.length">
          <i class="iconfont icon-tubiao-25"></i>
        </span>
      </div>
      <div v-for="(j, k) in item.formList" :key="k" class="border-container" style="border:0">
        <template v-for="(fields, i) in j.list" :key="i" >
          <el-form-item
            :class="[fields.componentType, { fullWidth: fields.config.width }]"
            :rules="fields.rules"
            :prop="'formList.' + k + '.list.' + i + '.value'"
            :label="fields.fieldName"
            :error="fields.rules[0].message"
            v-if="handleVisible(fields, j.list)"
          >
            <FromField :fields="fields" @form-change="handleChange(fields, index, j.list)" :id="id"/>
          </el-form-item>
        </template>
        <!-- <i @click="handleDelete(item.formList,k)" class="delete-icon"></i> -->
      </div>
    </el-form>
    <div class="dialog-footer mt-20 " >
      <el-button @click="cancle" >
        {{ t("table.cancel") }}
      </el-button>
      <el-button
        type="primary"
        :loading="submitLoading"
        @click="handleSubmit"
      >
        {{ t("table.confirm") }}
      </el-button>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, reactive, toRefs, ref, onMounted, nextTick, unref } from 'vue'
import { ArrayRowsItem } from '@/model/Index'
import { getPageList } from '@/apis/Form'
import { postUrl } from '@/apis/Dictionary'

import { ElMessage } from 'element-plus'

import { useI18n } from 'vue-i18n'
import { cloneDeep } from 'lodash'
import FromField from '@/components/common/FormField.vue'
import { rukuFormField } from './RukuFormField'
import AccountPreview from '@/views/business/outsourceCompany/AccountPreview/Index.vue'
// import MaterialTable from './MaterialTable.vue'
import MateriallDescription from '../materialInfo/MateriallDescription.vue'

export default defineComponent({
  components: { FromField, AccountPreview, MateriallDescription },
  props: {
    id: { type: Number, required: false, default: 0 },
    api: { type: String, required: true },
    handleResolveTempData: { type: Function, required: false },
    selectionArray: { type: Array, required: false, default: () => [] },
    from: { type: String, required: false, default: '' },
    mode: { type: String, required: false, default: '' },
    purchaseType: { type: Number, required: false, default: 1 },
    materialData: { type: Object, required: false, default: () => null },
    locationId: { type: Number, required: false, default: 0 },
    activeRow: { type: Object, required: false, default: () => null }
  },
  emits: ['update:visibel', 'submit'],

  setup(props, context) {
    const { t } = useI18n()

    const dataForm = ref([])

    const dataMap = reactive({
      fromFieldData: [],
      initFormData: cloneDeep(rukuFormField),
      from: props.from,
      mode: props.mode,
      purchaseType: props.purchaseType,
      submitLoading: false,
      detail: {
        supplierAccount: {},
        details: []
      } as any,
      ruleForm: {
        containsRate: '',
        invoiceType: null,
        supplierId: '',
        supplierAccountId: '',
        rate: null,
        type: '',
        branchName: '',
        account: '',
        mark: '',
        details: []
      },
      rules: {
        supplierId: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        supplierAccountId: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        containsRate: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        details: []
      },
      containsRateOption: [],
      supplierAccountption: [],
      typeOption: [],
      userPayTypeOption: [],
      dialogVisible: false,
      selectBusinessList: [],
      taxRateList: [],
      excludeIds: [],
      addType: '',

      materialOption: [],
      locationOption: [],

      handleSupplierCahnge(value: number) {
        if (!value) {
          dataMap.ruleForm.supplierAccountId = ''
        }
      },
      supplierAccountRemoteMethod() {
        const { supplierId } = dataMap.ruleForm
        if (!supplierId) {
          return
        }
        getPageList(`supplierAccount/page?page=1&size=999&supplierId=${supplierId}`).then((res: any) => {
          dataMap.supplierAccountption = res.data || []
        })
      },
      handleSupplierAccountChange(value: any) {
        const temp = dataMap.supplierAccountption.find((k: any) => k.id === value) || {}
        const tempType = dataMap.userPayTypeOption.find((k: any) => k.id === temp.type) || {}
        dataMap.ruleForm.type = temp.mark ? temp.mark : tempType.mark
        dataMap.ruleForm.branchName = temp.branchName
        dataMap.ruleForm.account = temp.account
      },
      handleRoundNum(number: number) {
        return Math.round(number * 100) / 100
      },
      cancle() {
        context.emit('update:visibel')
      },
      handleSubmit() {
        const Forms = unref(dataForm)
        const promises = Forms.map((form: any) => {
          return form.validate()
        })
        Promise.all(promises).then(async() => {
          try {
            const tempData = dataMap.handleFormData(cloneDeep(dataMap.fromFieldData)).list

            if (props.purchaseType === 1 && props.from !== 'local') {
              for (let i = 0; i < tempData.length; i++) {
                const item = tempData[0]
                if (item.virtualStorage) {
                  delete item.amount
                  delete item.locationId
                } else {
                  // const materialTemp = dataMap.detail.details.find((kk: any) => kk.id === item.materialId)
                  delete item.materialNo
                  const materialTemp = dataMap.detail.material
                  if (materialTemp.amount < item.amount) {
                    return ElMessage.error('入库数量不得大于采购数量！')
                  }
                }
              }
            }
            dataMap.submitLoading = true
            await postUrl('/storage/warehousing', { type: props.purchaseType, details: tempData })
            dataMap.submitLoading = false
            context.emit('update:visibel')
            context.emit('submit')
            ElMessage({
              message: '入库成功',
              type: 'success',
              duration: 2000
            })
          } catch (err:any) {
            console.log(err, 'err')
            dataMap.submitLoading = false
            if (err && err.errors) {
              err.errors.forEach((item: any) => {
                const field = dataMap.rules[item.field][0]
                if (field) {
                  field.message = null
                  nextTick(() => {
                    field.message = item.defaultMessage
                  })
                }
              })
            }
          }
        })
      },
      handleCalcTotal() {
        dataMap.ruleForm.details.forEach((item: any) => {
          item.total = Number(item.fee) * Number(item.amount)
        })
      },
      // clearValidate() {
      //   nextTick(() => {
      //     (dataForm.value as typeof ElForm).clearValidate()
      //   })
      // },
      handleVisible(fields: any) {
        if (fields.config.isVirtual) {
          return false
        }
        if (!fields.config.purchaseType) {
          return true
        }
        if (fields.config.purchaseType === props.purchaseType) {
          return true
        }
        return false
      },
      handleChange(fields: any) {
        if (fields.fieldKey === 'amount') {
          // const item = dataMap.detail.details.find((kk: any) => kk.id === fields.id)
          const item = dataMap.detail
          const tempValue = fields.value * 1
          fields.value = tempValue > item.amount ? item.amount : tempValue
          item.inputStorageNum = fields.value
        }
      },
      handleAddComand(item?: any, isVirtual?: false) {
        // item.virtualStorage = Number(isVirtual)
        const tempInitFormData = cloneDeep(dataMap.initFormData)
        const addContion = tempInitFormData[0].formList[0] as any
        if (item) {
          addContion.list.forEach((kk: any) => {
            kk.id = item.id
            if (kk.fieldKey === 'materialId') {
              kk.value = item.materialId
            } if (kk.fieldKey === 'materialNo') {
              kk.value = item.materialNo || item.no
            } else if (kk.fieldKey === 'amount') {
              kk.config.isVirtual = isVirtual
              const fromFieldDataContion = dataMap.fromFieldData[0]?.formList || []
              let usedAmount = 0
              fromFieldDataContion.forEach((aa: any) => {
                aa.list.forEach((bb: any) => {
                  if (bb.fieldKey === 'amount' && bb.id === item.id) {
                    usedAmount += Number(bb.value)
                  }
                })
              })

              kk.value = Number(item.amount) - (item.storageNum ? Number(item.storageNum) : 0) - usedAmount
              kk.config.maxlength = item.amount
            }
            // else if (kk.fieldKey === 'locationId') {
            //   kk.config.isVirtual = isVirtual
            // }
          })
        }
        if (props.materialData) {
          addContion.list.forEach((kk: any) => {
            if (kk.fieldKey === 'materialId') {
              kk.value = props.materialData.id
            } else if (kk.fieldKey === 'oldLocationId') {
              kk.value = props.materialData.oldLocationId
            }
          })
        }
        if (props.from === 'local' && [1, 3].includes(props.purchaseType)) {
          addContion.list.forEach((kk: any) => {
            if (kk.fieldKey === 'materialId') {
              kk.config.selectType = 2
              kk.config.url = 'material/page'
            }
            if (kk.fieldKey === 'locationId') {
              kk.value = props.locationId || ''
            }
          })
        }
        this.setFormOptions(addContion)

        if (dataMap.fromFieldData.length) {
          dataMap.fromFieldData[0].formList.push(cloneDeep(addContion))
        } else {
          dataMap.fromFieldData = cloneDeep(tempInitFormData)
        }
        dataMap.clearValidate()
      },
      handleDelete(formList: any, index: number) {
        // const row = formList[index]
        // if (row.id) {
        //   dataMap.deleteList.push(row)
        // }
        dataMap.detail.details[index].inputStorageNum = 0
        dataMap.detail.details[index].virtualStorage = 0

        formList.splice(index, 1)
      },
      clearValidate() {
        nextTick(() => {
          dataForm.value.forEach((form: any) => {
            form.clearValidate()
          })
        })
      },
      setFormOptions(addContion: any) {
        addContion.list.forEach((kk: any) => {
          if (kk.fieldKey === 'materialId') {
            kk.option = dataMap.materialOption
          } else if (['locationId', 'oldLocationId'].includes(kk.fieldKey)) {
            kk.option = dataMap.locationOption
          }
        })
      },
      handleFormData(formData: any) {
        const returnData = {} as any
        formData.forEach((k: any) => {
          const _list = [] as ArrayRowsItem
          k.formList.forEach((field: any) => {
            const _obj = {} as any
            field.list.forEach((k: any) => {
              if (!k.config.isVirtual) {
                Object.assign(_obj, dataMap.handleFieldData(k))
              }
              if (k.fieldKey === 'materialId') {
                // const tempData = dataMap.detail.details?.find((kk: any) => kk.id === k.value) || dataMap.detail.material || {}
                Object.assign(_obj, { purchaseDetailId: props.id })
              }
              _obj.virtualStorage = _obj.virtualStorage || k.config.isVirtual
              // Object.assign(_obj, { virtualStorage: _obj.virtualStorage || k.config.isVirtual })
            })
            _obj.amount = _obj.amount ? Number(_obj.amount) : 0
            _list.push(_obj)
            returnData[field.fieldKey] = _list
          })
        })
        return returnData
      },
      handleFieldData(fields: any) {
        if (fields.fieldKey) {
          fields = cloneDeep(fields)
          const returnObj = {}
          returnObj[fields.fieldKey] = fields.value
          return returnObj
        }
      }
    })

    onMounted(async() => {
      dataMap.clearValidate()
      if (props.activeRow) {
        dataMap.detail = props.activeRow
        dataMap.detail.materialNo = props.activeRow.material.no
        // getDetailById(props.api, props.id).then((res: any) => {
        //   dataMap.detail = res
        //   const tempArray = [] as any
        //   res.details.forEach((item: any) => {
        //     const tempObj = {
        //       ...item,
        //       materialNo: item.material.no,
        //       materialClass: item.material.materialClass,
        //       materialUnit: item.material.materialUnit,
        //       materialStandard: item.material.standard,
        //       materialId: item.material.id,
        //       materialBrand: item.material.brand,
        //       materialName: item.material.name,
        //       materialModel: item.material.model,
        //       materialCode: item.material.code,
        //       materialParameter: item.material.parameter,
        //       materialDevice: item.material.device,
        //       id: item.material.id,
        //       name: item.material.name,
        //       total: dataMap.handleRoundNum(item.amount * item.fee)
        //     }

        //     if (item.list) {
        //       item.list.forEach((k: any, index: number) => {
        //         tempArray.push({
        //           ...tempObj,
        //           materialAmount: k.amount,
        //           materialCreateUser: k.createUser,
        //           prePurchaseId: k.id,
        //           total: index === 0 ? tempObj.total : 0,
        //           fee: index === 0 ? item.fee : 0,
        //           amount: index === 0 ? item.amount : 0
        //         })
        //       })
        //     } else {
        //       tempArray.push(tempObj)
        //     }
        //   })
        //   dataMap.detail.details = tempArray
        //   dataMap.materialOption = uniqBy(dataMap.detail.details, 'id')
        // })
      }
      dataMap.locationOption = await getPageList('/location/tree') || []
      dataMap.materialOption = [dataMap.detail.material]
      dataMap.handleAddComand(dataMap.detail)

      // if (props.from === 'local') {
      //   if (props.purchaseType === 2) {
      //     dataMap.materialOption = Object.keys(props.materialData).length ? [props.materialData] : []
      //   }
      //   dataMap.handleAddComand()
      // }
    })
    return { t, ...toRefs(dataMap), dataForm }
  }
})
</script>
<style. lang="scss">
  .el-table .el-table__cell.is-hidden>*{
    visibility:visible
  }
</style.>
